module.exports = __webpack_public_path__ + "static/media/car_left.1a96d531.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/car_left.png
// module id = 337
// module chunks = 0